import { storage } from "../firebase";
import { ref, deleteObject } from "firebase/storage";

export const deleteMediaFromServer = async (mediaUrl) => {
  if (!mediaUrl) return true;
  try {
    const fileRef = ref(storage, mediaUrl);
    await deleteObject(fileRef);
    return true;
  } catch (e) {
    console.log("Firebase storage delete:", e?.message);
    return true;
  }
};
